import HomePage from "./pages/HomePage";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./common/Header";
import Footer from "./common/Footer";
import VehicleSelection from "./components/VehicleSelection";
import ContactDetailsPage from "./components/ContactDetailsPage";
import VehicleServicePage from "./pages/VehicleServicePage"; // Add this import
import { BookingProvider } from "./components/BookingContext";
import ScrollToTop from "./common/ScrollToTop";
import InnovaCrystaBangalore from "./pages/Vehicles/InnovaCrystaBangalore"
import InnovaHybridBangalore from "./pages/Vehicles/InnovaHybridBangalore"
import Urbania16SeaterBangalore from "./pages/Vehicles/Urbania16SeaterBangalore"
import Urbania12SeaterBangalore from "./pages/Vehicles/Urbania12SeaterBangalore"
import Urbania9SeaterBangalore from "./pages/Vehicles/Urbania9SeaterBangalore"
import ErtigaBangalore from "./pages/Vehicles/ErtigaBangalore"
import TempoTraveller12Seater from "./pages/Vehicles/TempoTraveller12Seater"
import TempoTraveller9Seater from "./pages/Vehicles/TempoTraveller9Seater"
import Bus20SeaterBangalore from "./pages/Vehicles/Bus20SeaterBangalore"
import Bus30SeaterBangalore from "./pages/Vehicles/Bus30SeaterBangalore"
import Bus40SeaterBangalore from "./pages/Vehicles/Bus40SeaterBangalore"
import Bus50SeaterBangalore from "./pages/Vehicles/Bus50SeaterBangalore"
import Contact from "./pages/ContactPage"
import vehicleselection from "./components/VehicleSelection"

function App() {
  return (
    <BookingProvider>
      <Router>
        <ScrollToTop />
        <Header />  
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vehicle-selection" element={<VehicleSelection />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact-details" element={<ContactDetailsPage />} />
          
          {/* Vehicle Service Routes */}
          {/* Force Urbania Routes */}
          <Route path="/urbania-16-seater-bangalore" element={<Urbania16SeaterBangalore />} />
          <Route path="/urbania-12-seater-bangalore" element={<Urbania12SeaterBangalore />} />
          <Route path="/urbania-9-seater-bangalore" element={<Urbania9SeaterBangalore />} />
          
          {/* Tempo Traveller Routes */}
          <Route path="/12-seater-tempo-traveller-booking-bangalore" element={<TempoTraveller12Seater />} />
          <Route path="/9-seater-tempo-traveller-booking-bangalore" element={<TempoTraveller9Seater />} />
          
          {/* Innova Hybrid Route */}
          <Route path="/innovahybrid-booking-bangalore" element={<InnovaHybridBangalore />} />
          <Route path="/innova-booking-bangalore" element={<InnovaCrystaBangalore />} />
          <Route path="/ertiga-car-rental-bangalore" element={<ErtigaBangalore />} />
          
          {/* Bus Routes */}
          <Route path="/20-seater-bus-rental-bangalore" element={<Bus20SeaterBangalore />} />
          <Route path="/30-seater-bus-rental-bangalore" element={<Bus30SeaterBangalore />} />
          <Route path="/40-seater-bus-rental-bangalore" element={<Bus40SeaterBangalore />} />
          <Route path="/50-seater-bus-rental-bangalore" element={<Bus50SeaterBangalore />} />
        </Routes>
        <Footer />
      </Router>
    </BookingProvider>
  );
}

export default App;